import React, { useEffect, useRef, useState } from "react";
import RecentJobs from "./recent_jobs/RecentJobs";
import InsideUc from "./inside_uc/InsideUc";
import Perks from "./perks/Perks";
import Founders from "./founders/Founders";
import Header from "../common/header/Header";
import WideHeader from "./wide_header/WideHeader";
import Culture from "./culture/Culture";
import Journey from "./journey/UCJourney";
import Leaders from "./leadership/leadership";
import Footer from "./footer/Footer";
import CareerHeader from "./career_header/CareerHeader";

const Home = () => {
  const [selectedTab, setSelectedTab] = useState("1");

  const insideUcRef = useRef();
  const recentJobsRef = useRef();
  const perksRef = useRef();
  const cultureRef = useRef();
  const journeyRef = useRef();
  const foundersRef = useRef();

  const handleObserver = (entities, observer) => {
    const index = entities[0].target.getAttribute("data-index");
    if (entities[0].isIntersecting) {
      setSelectedTab(index);
    }
  };

  const options = {
    rootMargin: "-30% 0px -70% 0px",
    threshold: 0,
  };

  useEffect(() => {
    new IntersectionObserver(handleObserver, options).observe(
      insideUcRef.current
    );
    new IntersectionObserver(handleObserver, options).observe(
      recentJobsRef.current
    );
    new IntersectionObserver(handleObserver, options).observe(perksRef.current);
    new IntersectionObserver(handleObserver, options).observe(
      cultureRef.current
    );
    new IntersectionObserver(handleObserver, options).observe(
      journeyRef.current
    );
    new IntersectionObserver(handleObserver, options).observe(
      foundersRef.current
    );
  });

  return (
    <div>
      <Header />
      <WideHeader />
      <CareerHeader selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <div ref={insideUcRef} data-index="1">
        <InsideUc />
      </div>
      <div ref={recentJobsRef} data-index="2">
        <RecentJobs />
      </div>
      <div ref={perksRef} data-index="3">
        <Perks />
      </div>
      <div ref={cultureRef} data-index="4">
        <Culture />
      </div>
      <div ref={journeyRef} data-index="5">
        <Journey />
      </div>
      <div ref={foundersRef} data-index="6">
        <Founders />
        <Leaders />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
